<template>
  <transition name="slidefade">
    <div v-if="show" class="modal">
      <div class="wrapContent">
        <div class="head">
          <!-- <img
            class="backBtn mask-image"
            @click="$emit('close', true)"
            src="@/assets/img/left-arrow.svg"
            alt=""
          /> -->
          <div @click="$emit('close', true)" class="backBtn mask-image"></div>
          <input class="queryInput" type="text" v-model="queryInput" />
          <div :class="[{ disable: fetching }, 'searchBtn']" @click="search()">
            ค้นหา
          </div>
        </div>
        <div class="result">
          <ProductList
            :isAddOrder="isAddOrder"
            :products="products"
            :fetching="fetching"
            :error="error"
            :endList="endList"
            :page="page"
            :nodata="nodata"
            :pageSize="pageSize"
            @scrollEnd="
              if (products.length > 0) {
                getProducts();
              }
            "
            @clickItem="clickItem"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ProductList from "@/views/productsPage/ProductList";
import { GET } from "@/utils/http";

export default {
  name: "SearchProduct",
  components: { ProductList },
  props: {
    show: Boolean,
    isAddOrder: Boolean,
  },
  data() {
    return {
      queryInput: "",
      products: [],
      fetching: false,
      error: false,
      endList: false,
      page: 1,
      pageSize: 5,
    };
  },
  computed: {
    nodata() {
      return !this.fetching && this.products.length <= 0 && !this.error;
    },
  },
  watch: {
    show() {
      if (this.show) {
        console.log("show");
        history.pushState(
          {},
          null,
          decodeURI(this.$route.fullPath) + "#search-product"
        );
        document.body.classList.add("search-open");
      } else {
        document.body.classList.remove("search-open");
        this.$router.back();
      }
    },
  },
  methods: {
    async getProducts() {
      try {
        this.fetching = true;

        const shopId = this.$isSeller ? this.$myShop.id : this.$sellerShop.id;
        const { status, body } = await GET(
          `/api/shops/${shopId}/products?page=${this.page}&limit=${this.pageSize}&query=${this.queryInput}`
        );

        if (status !== 200) {
          throw "not ok";
        }

        this.products.push(...body.data);

        if (this.page >= body.lastPage) {
          this.endList = true;
        } else {
          this.page++;
        }
      } catch (err) {
        console.error(err);
        this.error = true;
      } finally {
        this.fetching = false;
      }
    },
    search() {
      this.products = [];
      this.endList = false;
      this.page = 1;
      this.getProducts();
    },
    clickItem(item) {
      this.queryInput = "";
      this.$emit("result", item);
    },
  },
  mounted() {
    window.onhashchange = (e) => {
      console.log("in modal", e);
      if (!e.target.location.hash.includes("#search-product")) {
        this.$emit("close", true);
        document.body.classList.remove("search-open");
      }
    };
    this.search();
  },
};
</script>

<style lang="scss" scoped>
/* The Modal (background) */
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 10; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  background-color: rgb(255, 255, 255); /* Fallback color */
  box-sizing: border-box;
}

.wrapContent {
  width: 100%;
  height: 100%;
}
/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  width: 100%;
  height: 100%;
}

.backBtn {
  width: 28px;
  margin-right: 8px;
  height: 28px;
  mask-image: url(~@/assets/img/left-arrow.svg);
}

.queryInput {
  padding: 5px 10px;
}

input {
  width: calc(100% - 100px);
  height: 40px;
  border-radius: 10px;
  font-size: 16px;
  border: 1px solid #b9b9b9;
  background: #ffffffbd;
}

.head {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  padding: 10px;
  padding-top: 15px;
  overflow: hidden;
  z-index: 10;
}

.searchBtn {
  margin: 0 auto;
  width: 60px;
  display: inline-flex;
  margin: 0 8px;
  border-radius: 10px;
  justify-content: center;
  background: #ffffffc7;
  align-items: center;
  padding: 2px;
  font-size: 14px;
  /* box-shadow: 0 0px 2px 0 rgb(0 0 0 / 50%); */
  border: 1px solid var(--primary-color);
  height: 40px;
  color: var(--primary-color);
  // font-weight: bold;
  &.disable {
    pointer-events: none;
    background: #696969b0;
    box-shadow: none;
    color: #a3a3a3;
  }
  &:active {
    background: var(--primary-color);
  }
}

.result {
  overflow-y: auto;
  height: 100%;
  padding: 70px 10px 25px 10px;
}

.mask-image {
  background-color: var(--primary-color);
  mask-repeat: no-repeat;
  mask-size: contain;
  mask-position: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.3s;
}

.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(100%, 0);
}

.slidefade-leave-active,
.slidefade-enter-active {
  transition: 0.4s, opacity 0.5s;
}

.slidefade-enter {
  transform: translate(100%, 0);
  opacity: 0;
}
.slidefade-leave-to {
  opacity: 0;
  transform: translate(100%, 0);
}
</style>